<div #card class="mat-elevation-z7 fixed-card" [ngClass]="{'show-chat': showChat }" @cardAnimation *ngIf="showContent">

  <div *ngIf="isLoading" class="progress-layout">
    <div class="center-box">
      <div class="spinner"> </div>
    </div>
  </div>

  <div *ngIf="showChat" [ngClass]="{header: true}">
    <ng-container *ngIf="showChat">
      <button [disabled]="isLoading" @slideDown (click)="isSmallScreen ? toggleContent($event): backFromChat()" mat-icon-button>
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <h4 [ngSwitch]="isGlobalOnline" @slideDown (@slideDown.done)="doneAnimation()">Chat room
        <span *ngSwitchCase="true"  class="status-indicator online">Online</span>
        <span *ngSwitchDefault class="status-indicator offline">Offline</span>
      </h4>
      <div class="spacer"></div>
      <button [disabled]="isLoading" @slideDown (click)="isSmallScreen ? backFromChat(): toggleContent($event)" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </ng-container>
  </div>
  <div class="card-body">

    <div *ngIf="!showChat" class="card-navigation">
      <img class="logo" src="/assets/img/logo.png" alt="LOGO">
      <h4>Live Chat</h4>
      <div class="spacer"></div>
      <button (click)="toggleContent()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>

    <div *ngIf="!showChat" class="overlap-card">
      <form [formGroup]="infoFormGroup">

        <div class="form-group">
          <label for="name">Your name</label>
          <input formControlName="name" autofocus  maxlength="50" class="form-control"
                 id="name" type="text" placeholder="Name" required>
        </div>


        <div class="form-group">
          <label for="email">Your email</label>
          <input formControlName="email" autofocus maxlength="50" class="form-control"
                 id="email" type="email" placeholder="Email" required>
        </div>

        <div class="form-group">
          <label for="message">Your message</label>
          <textarea rows="4" formControlName="message" style="resize: none" autofocus maxlength="500" class="form-control"
                    id="message" type="text" placeholder="Message" required></textarea>
        </div>


      </form>

      <button (click)="submitInfo()" [disabled]="isLoading || infoFormGroup.invalid" class="btn btn-primary button-new">Start conversation</button>

    </div>
    <div @chatContent [@listAnimation]="messages.length"
         *ngIf="showChat"
         [(attr.scrollTop)]="messageListScrollTop"
         [(attr.scrollHeight)]="messageListScrollHeight"
         #messageList
         class="message-list">


      <div title="{{message.createdAt | date: 'medium'}}"  *ngFor="let message of messages;" [ngClass]="{'message-item': true,
      'item-align-right': checkIfMyMessage(message),
      'item-align-center': message.type === 2}" >
        {{message.body}}
      </div>

      <div class="indicator" *ngIf="showTypingIndicator">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>

    <div @slideDown *ngIf="showChat" class="card-footer">
      <input #inputMessage autofocus [formControl]="messageControl" (keyup.enter)="onSendMessage()" placeholder="Send a message..." class="message-input" title="Message">
      <button class="send-icon" [disabled]="isLoading || messageControl.disabled" [@sendAnimation]="messageControl.invalid ? 'hide': 'show'" mat-icon-button (click)="onSendMessage($event)"><mat-icon>send</mat-icon></button>
    </div>
  </div>

</div>

<button  class="fixed-bottom" *ngIf="!showContent" (click)="toggleContent($event)" mat-fab mat-button>
  <mat-icon matBadge="{{badge | badgeCount}}" [matBadgeHidden]="!badge" matBadgeColor="warn" class="chat-button">chat_bubble</mat-icon>
</button>
